<template>
    <div>
        <h1 class="display-heading">Employee Credit Usage</h1>

        <div class="card mb-3">
            <div class="card-body">
                <!-- <p><b>Employee Annual Limit Last Reset Date:</b> {{ annualLimitResetDates.lastReset ? annualLimitResetDates.lastReset : '-'}}</p>
                <p><b>Employee Annual Limit Next Reset Date:</b> {{ annualLimitResetDates.nextReset ? annualLimitResetDates.nextReset : '-'}}</p> -->
                <div class="form-group mr-3 d-flex align-items-baseline">
                    <label class="mr-2 font-weight-bold">View Limit Type:</label>
                    <select style="width: 150px" name="filterLimitType" class="form-control" v-model="filterLimitType">
                        <option value="Annually">Annually</option>
                        <option value="Monthly">Monthly</option>
                        <option value="Weekly">Weekly</option>
                    </select>
                </div>

                <hr>
                <p><b>Filter By Employee</b></p>
                <div  class="form-group">
                    <div class="row">
                    <div class="col-lg-4">
                        <input class="form-control" placeholder="Enter employee name"  v-model="employeeSearch" >
                    </div>
                </div>
                </div>
                <button class="btn btn-primary btn-primary-insv" type="button" @click="getCompanyEmployeeSpending">Search Employee</button>
                &nbsp;<button class="btn btn-secondary" type="button" @click="resetEmployeeFilter">Clear Search</button>
            </div>
        </div>

        <div ref="tableSection">
            <table ref="listTable" class="table table-hover">
                <colgroup>
                    <col width="40">
                    <col width="200">
                    <col width="150">
                    <col width="150">
                    <col width="150">
                    <col>
                </colgroup>
                <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Employee Name</th>
                        <th scope="col">Last Reset Date</th>
                        <th scope="col">Type</th>
                        <th scope="col" class="text-right">Usage</th>
                        <th scope="col"></th>
                    </tr>
                </thead>

                <tbody>
                    <tr v-show="historyList.length === 0">
                        <td :colspan="columnsCount" class="text-center font-italic">
                            {{isTableLoading ? "Loading Data": "No Data"}}
                        </td>
                    </tr>
                    <template v-for="(historyItem, index) in historyList">
                        <tr :key="index * 3">
                            <th scope="row" :rowspan="historyItem.rows">{{((pagination.currentPage - 1) *pagination.pageSize ) + index + 1}}</th>
                            <td class="text-nowrap" :rowspan="historyItem.rows">{{historyItem.employeeName}}</td>
                            <td class="text-nowrap" :rowspan="historyItem.rows">{{historyItem.currentResetDate}}</td>
                            <td class="text-nowrap">Principal</td>
                            <template v-if="historyItem.principalCurrentLimit != 0">
                                <td class="text-nowrap text-right">
                                    RM{{historyItem.principalCurrentUsage}} / RM{{historyItem.principalCurrentLimit}}
                                </td>
                                <td class="text-nowrap">
                                    <div class="progress">
                                        <div :class="['progress-bar', {
                                            'bg-success': historyItem.principalCurrentUsagePercentage<=25,
                                            'bg-info': historyItem.principalCurrentUsagePercentage>25 && historyItem.principalCurrentUsagePercentage<=50,
                                            'bg-warning': historyItem.principalCurrentUsagePercentage>50 && historyItem.principalCurrentUsagePercentage<=75,
                                            'bg-danger': historyItem.principalCurrentUsagePercentage>75
                                        }]" role="progressbar" :style="`width: ${historyItem.principalCurrentUsagePercentageDisplay}`" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                    </div>
                                </td>
                            </template>
                            <template v-else>
                                <td class="text-nowrap" colspan="2">
                                    {{filterLimitType}} limit not set.
                                </td>
                            </template>
                        </tr>
                        <tr v-if="historyItem.spouseBenefit" :key="index * 3 + 1">
                            <td class="text-nowrap border-top-0">Spouse</td>
                            <template v-if="!historyItem.hasFamilyLimit">
                                <template v-if="historyItem.spouseCurrentLimit != 0">
                                    <td class="text-nowrap border-top-0 text-right">
                                        RM{{historyItem.spouseCurrentUsage}} / RM{{historyItem.spouseCurrentLimit}}
                                    </td>
                                    <td class="text-nowrap border-top-0">
                                        <div class="progress">
                                            <div :class="['progress-bar', {
                                                'bg-success': historyItem.spouseCurrentUsagePercentage<=25,
                                                'bg-info': historyItem.spouseCurrentUsagePercentage>25 && historyItem.spouseCurrentUsagePercentage<=50,
                                                'bg-warning': historyItem.spouseCurrentUsagePercentage>50 && historyItem.spouseCurrentUsagePercentage<=75,
                                                'bg-danger': historyItem.spouseCurrentUsagePercentage>75
                                            }]" role="progressbar" :style="`width: ${historyItem.spouseCurrentUsagePercentageDisplay}`" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>
                                    </td>
                                </template>
                                <template v-else>
                                    <td class="text-nowrap border-top-0" colspan="2">
                                        {{filterLimitType}} limit not set.
                                    </td>
                                </template>
                            </template>
                            <template v-else>
                                <td class="text-nowrap border-top-0" colspan="2">
                                    Shares limit with principal.
                                </td>
                            </template>
                        </tr>
                        <tr v-if="historyItem.dependentBenefit" :key="index * 3 + 2">
                            <td class="text-nowrap border-top-0">Dependent</td>
                            <template v-if="!historyItem.hasFamilyLimit">
                                <template v-if="historyItem.dependentCurrentLimit != 0">
                                    <td class="text-nowrap border-top-0 text-right">
                                        RM{{historyItem.dependentCurrentUsage}} / RM{{historyItem.dependentCurrentLimit}}
                                    </td>
                                    <td class="text-nowrap border-top-0">
                                        <div class="progress">
                                            <div :class="['progress-bar', {
                                                'bg-success': historyItem.dependentCurrentUsagePercentage<=25,
                                                'bg-info': historyItem.dependentCurrentUsagePercentage>25 && historyItem.dependentCurrentUsagePercentage<=50,
                                                'bg-warning': historyItem.dependentCurrentUsagePercentage>50 && historyItem.dependentCurrentUsagePercentage<=75,
                                                'bg-danger': historyItem.dependentCurrentUsagePercentage>75
                                            }]" role="progressbar" :style="`width: ${historyItem.dependentCurrentUsagePercentageDisplay}`" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>
                                    </td>
                                </template>
                                <template v-else>
                                    <td class="text-nowrap border-top-0" colspan="2">
                                        {{filterLimitType}} limit not set.
                                    </td>
                                </template>
                            </template>
                            <template v-else>
                                <td class="text-nowrap border-top-0" colspan="2">
                                    Shares limit with principal.
                                </td>
                            </template>
                        </tr>
                    </template>
                </tbody>
            </table>
            <pagination v-model="pagination.currentPage"
                :totalPages="pagination.totalPages"
                :scrollPosition="pagination.scrollPosition">
            </pagination>
        </div>
    </div>
</template>

<script>
import {
    convertDateToDDMMYYYY
} from '@/utilities';
import pagination from '@/components/pagination';
export default {
    'name': 'EmployeeSpendingReport',
    'components': {
        pagination
    },
    mounted () {
        const pageContent = document.getElementsByClassName('page-content');
        pageContent[0].classList.add('wide-version');
        this.columnsCount = this.$refs.listTable.rows[0].cells.length;

        this.getCompanyEmployeeSpending();

        // initialize scroll position
        this.$nextTick(() => {
            this.pagination.scrollPosition = this.$refs.tableSection.getBoundingClientRect().top + window.scrollY - document.querySelector('.top-navigation').clientHeight;
        });

        // this.getCompanyAnnualLimitResetDates();
    },
    destroyed () {
        const pageContent = document.getElementsByClassName('page-content');
        pageContent[0].classList.remove('wide-version');
    },
    'computed': {
        currentPage () {
            return this.pagination.currentPage;
        }
    },
    'watch': {
        currentPage () {
            this.$nextTick(() => {
                this.getCompanyEmployeeSpending();
            });
        },
        'filterLimitType' (value) {
            if (value === 'Annually') {
                this.historyList.forEach(element => {
                    element.principalCurrentLimit = element.annualLimit;
                    element.principalCurrentUsage = element.principalAnnualUsage;
                    element.principalCurrentUsagePercentage = element.principalAnnualUsagePercentage;
                    element.principalCurrentUsagePercentageDisplay = element.principalAnnualUsagePercentageDisplay;
                    element.spouseCurrentLimit = element.spouseAnnualLimit;
                    element.spouseCurrentUsage = element.spouseAnnualUsage;
                    element.spouseCurrentUsagePercentage = element.spouseAnnualUsagePercentage;
                    element.spouseCurrentUsagePercentageDisplay = element.spouseAnnualUsagePercentageDisplay;
                    element.dependentCurrentLimit = element.dependentAnnualLimit;
                    element.dependentCurrentUsage = element.dependentAnnualUsage;
                    element.dependentCurrentUsagePercentage = element.dependentAnnualUsagePercentage;
                    element.dependentCurrentUsagePercentageDisplay = element.dependentAnnualUsagePercentageDisplay;
                    element.currentResetDate = element.annualLimitResetDate;
                });
            } else if (value === 'Monthly') {
                this.historyList.forEach(element => {
                    element.principalCurrentLimit = element.monthlyLimit;
                    element.principalCurrentUsage = element.principalMonthlyUsage;
                    element.principalCurrentUsagePercentage = element.principalMonthlyUsagePercentage;
                    element.principalCurrentUsagePercentageDisplay = element.principalMonthlyUsagePercentageDisplay;
                    element.spouseCurrentLimit = element.monthlyLimit;
                    element.spouseCurrentUsage = element.spouseMonthlyUsage;
                    element.spouseCurrentUsagePercentage = element.spouseMonthlyUsagePercentage;
                    element.spouseCurrentUsagePercentageDisplay = element.spouseMonthlyUsagePercentageDisplay;
                    element.dependentCurrentLimit = element.monthlyLimit;
                    element.dependentCurrentUsage = element.dependentMonthlyUsage;
                    element.dependentCurrentUsagePercentage = element.dependentMonthlyUsagePercentage;
                    element.dependentCurrentUsagePercentageDisplay = element.dependentMonthlyUsagePercentageDisplay;
                    element.currentResetDate = element.monthlyLimitResetDate;
                });
            } else if (value === 'Weekly') {
                this.historyList.forEach(element => {
                    element.principalCurrentLimit = element.weeklyLimit;
                    element.principalCurrentUsage = element.principalWeeklyUsage;
                    element.principalCurrentUsagePercentage = element.principalWeeklyUsagePercentage;
                    element.principalCurrentUsagePercentageDisplay = element.principalWeeklyUsagePercentageDisplay;
                    element.spouseCurrentLimit = element.weeklyLimit;
                    element.spouseCurrentUsage = element.spouseWeeklyUsage;
                    element.spouseCurrentUsagePercentage = element.spouseWeeklyUsagePercentage;
                    element.spouseCurrentUsagePercentageDisplay = element.spouseWeeklyUsagePercentageDisplay;
                    element.dependentCurrentLimit = element.weeklyLimit;
                    element.dependentCurrentUsage = element.dependentWeeklyUsage;
                    element.dependentCurrentUsagePercentage = element.dependentWeeklyUsagePercentage;
                    element.dependentCurrentUsagePercentageDisplay = element.dependentWeeklyUsagePercentageDisplay;
                    element.currentResetDate = element.weeklyLimitResetDate;
                });
            }
        }
    },
    data () {
        return {
            'historyList': [],
            'columnsCount': 1,
            'isTableLoading': true,
            'pagination': {
                'currentPage': 1,
                'totalPages': 0,
                'pageSize': 20,
                'scrollPosition': 0
            },
            'filterLimitType': 'Annually',
            'employeeSearch': ''
        };
    },
    'methods': {
        getCompanyEmployeeSpending () {
            this.axios.post('CompanyCredit/GetEmployeeSpending', {
                'p': this.pagination.currentPage,
                'ps': this.pagination.pageSize,
                'e': this.employeeSearch
            }).then(({
                data
            }) => {
                this.isTableLoading = false;
                let pagedResult = data.data;

                this.pagination.currentPage = pagedResult.p;
                this.pagination.totalPages = pagedResult.c;

                let list = pagedResult.l;
                this.historyList = list.map((item) => ({
                    'employeeName': item.en,
                    'tierName': item.tn,
                    'annualLimitResetDate': convertDateToDDMMYYYY(item.alrd),
                    'monthlyLimitResetDate': convertDateToDDMMYYYY(item.mlrd),
                    'weeklyLimitResetDate': convertDateToDDMMYYYY(item.wlrd),
                    'annualLimit': item.al,
                    'monthlyLimit': item.ml,
                    'weeklyLimit': item.wl,
                    'principalSpendings': item.ps.map((ps) => ({
                        'usage': ps.u,
                        'date': ps.d
                    })),
                    'spouseBenefit': item.sb,
                    'spouseAnnualLimit': item.sal,
                    'spouseSpendings': item.ss.map((ss) => ({
                        'usage': ss.u,
                        'date': ss.d
                    })),
                    'dependentBenefit': item.db,
                    'dependentAnnualLimit': item.dal,
                    'dependentSpendings': item.ds.map((ds) => ({
                        'usage': ds.u,
                        'date': ds.d
                    })),
                    'principalAnnualUsage': item.pau,
                    'principalAnnualUsagePercentage': item.paup,
                    'principalAnnualUsagePercentageDisplay': item.paupd,
                    'principalMonthlyUsage': item.pmu,
                    'principalMonthlyUsagePercentage': item.pmup,
                    'principalMonthlyUsagePercentageDisplay': item.pmupd,
                    'principalWeeklyUsage': item.pwu,
                    'principalWeeklyUsagePercentage': item.pwup,
                    'principalWeeklyUsagePercentageDisplay': item.pwupd,
                    'hasFamilyLimit': item.hfl,
                    'spouseAnnualUsage': item.sau,
                    'spouseAnnualUsagePercentage': item.saup,
                    'spouseAnnualUsagePercentageDisplay': item.saupd,
                    'spouseMonthlyUsage': item.smu,
                    'spouseMonthlyUsagePercentage': item.smup,
                    'spouseMonthlyUsagePercentageDisplay': item.smupd,
                    'spouseWeeklyUsage': item.swu,
                    'spouseWeeklyUsagePercentage': item.swup,
                    'spouseWeeklyUsagePercentageDisplay': item.swupd,
                    'dependentAnnualUsage': item.dau,
                    'dependentAnnualUsagePercentage': item.daup,
                    'dependentAnnualUsagePercentageDisplay': item.daupd,
                    'dependentMonthlyUsage': item.dmu,
                    'dependentMonthlyUsagePercentage': item.dmup,
                    'dependentMonthlyUsagePercentageDisplay': item.dmupd,
                    'dependentWeeklyUsage': item.dwu,
                    'dependentWeeklyUsagePercentage': item.dwup,
                    'dependentWeeklyUsagePercentageDisplay': item.dwupd,
                    // Default = Annual
                    'principalCurrentLimit': item.al,
                    'principalCurrentUsage': item.pau,
                    'principalCurrentUsagePercentage': item.paup,
                    'principalCurrentUsagePercentageDisplay': item.paupd,
                    'spouseCurrentLimit': item.sal,
                    'spouseCurrentUsage': item.sau,
                    'spouseCurrentUsagePercentage': item.saup,
                    'spouseCurrentUsagePercentageDisplay': item.saupd,
                    'dependentCurrentLimit': item.dal,
                    'dependentCurrentUsage': item.dau,
                    'dependentCurrentUsagePercentage': item.daup,
                    'dependentCurrentUsagePercentageDisplay': item.daupd,
                    'currentResetDate': convertDateToDDMMYYYY(item.alrd),
                    'rows': 1 + (item.sb ? 1 : 0) + (item.db ? 1 : 0)
                }));
            });
        },
        resetEmployeeFilter () {
            this.pagination.currentPage = 1;
            this.employeeSearch = '';
            this.getCompanyEmployeeSpending();
        }
        // getCompanyAnnualLimitResetDates () {
        //     this.axios.get('CompanyCredit/GetAnnualLimitResetDates').then(({
        //         data
        //     }) => {
        //         if (data.data) {
        //             this.annualLimitResetDates.lastReset = data.data.allr ? convertDateToDDMMYYYY(data.data.allr) : null;
        //             this.annualLimitResetDates.nextReset = data.data.alnr ? convertDateToDDMMYYYY(data.data.alnr) : null;
        //         }
        //     });
        // }
    }
};
</script>

<style>

</style>
